<div class="top">
	<div class="message" matSnackBarLabel>
		@if (typeIcon) {
			<mat-icon class="type-icon" [title]="data.tooltip">{{
				typeIcon
			}}</mat-icon>
		}
		<span>{{ data.message }}</span>
	</div>
	<div matSnackBarAction>
		@if (!data.duration) {
			<button
				matSnackBarAction
				mat-icon-button
				mat-large-icon-button
				(click)="data.dismiss()"
			>
				<mat-icon>close</mat-icon>
			</button>
		}
	</div>
</div>
